import React from 'react';
import PropTypes from 'prop-types';

const ConversationSettings = ({ display, conversationId, archive }) => {
  if (!display) { return null; }

  const archiveConversation = () => {
    if (confirm('To unarchive the conversation, send the other user a message through their profile.')) {
      archive(conversationId);
    }
  };

  return (
    <aside className="conversation-settings nav-dropdown conversation-dropdown">
      <div className="nav-dropdown-contents">
        <div className="t4 w3 nav-dropdown-header">Settings</div>
        <p className="t4 w3 text-blue1">
          <span onClick={archiveConversation}>Archive conversation</span>
        </p>
      </div>
    </aside>
  );
};

ConversationSettings.propTypes = {
  display: PropTypes.bool.isRequired,
  conversationId: PropTypes.string,
  archive: PropTypes.func.isRequired
};

export default ConversationSettings;
